import React, { useEffect, useState } from "react";
import { FloatingPanels } from "orcs-design-system";
import { useTheme } from "styled-components";
import themeGet from "@styled-system/theme-get";
import { replace } from "lodash";
import { useReactFlowContext } from "src/contexts/reactFlowContext";

const COSMOS_UI_SIDE_NAV_OFFSET = 4;

const FloatingControl = () => {
  const themeContext = useTheme();
  const { panels, onClickIcon } = useReactFlowContext();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Return null if there are no panels to display
  // This prevents the visual artifact when no floating controls should be shown
  if (!panels || panels.length === 0) {
    return null;
  }

  const themeSpacingGap = Number(
    Number(replace(themeGet("space.r")({ theme: themeContext }), "px", ""))
  );

  const navBarSize = Number(
    replace(
      themeGet("appScale.newNavBarSize")({ theme: themeContext }),
      "px",
      ""
    )
  );

  const bottomPosition = windowWidth < 900 ? navBarSize : themeSpacingGap;

  const leftPosition = navBarSize / 2 - COSMOS_UI_SIDE_NAV_OFFSET;

  return (
    <FloatingPanels
      panels={panels}
      onClick={onClickIcon}
      position={{
        bottom: bottomPosition,
        left: leftPosition,
      }}
      centered={true}
      alignPanels="center"
      zIndex={22}
    />
  );
};

export default FloatingControl;
